/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/card';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SearchCardsRequest": {
                "fields": {
                  "filter": {
                    "type": ".squareup.corporate_card.service.SearchCardsRequest.Filter",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Filter": {
                    "fields": {
                      "ids": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "merchantIds": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "excludeDetails": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "SearchCardsResponse": {
                "fields": {
                  "cards": {
                    "type": ".squareup.corporate_card.resources.Card",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchCardsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchCardsRequest?.nested?.Filter && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchCardsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchCardsRequest @ squareup/corporate_card/service/search_cards.proto at 9:1
 */
export const SearchCardsRequest = $root.lookupType('squareup.corporate_card.service.SearchCardsRequest');
fixType(SearchCardsRequest);
Builder.createAndAttachToType(SearchCardsRequest);
/**
 * SOURCE Filter @ squareup/corporate_card/service/search_cards.proto at 10:3
 */
SearchCardsRequest.Filter = $root.lookupType('squareup.corporate_card.service.SearchCardsRequest.Filter');
fixType(SearchCardsRequest.Filter);
Builder.createAndAttachToType(SearchCardsRequest.Filter);
/**
 * SOURCE SearchCardsResponse @ squareup/corporate_card/service/search_cards.proto at 27:1
 */
export const SearchCardsResponse = $root.lookupType('squareup.corporate_card.service.SearchCardsResponse');
fixType(SearchCardsResponse);
Builder.createAndAttachToType(SearchCardsResponse);